/* Subtle scroll parallax. Desktop only, transform-only, rAF-throttled,
   reduced-motion safe. Targets container layers so it composes with the
   existing float keyframes instead of overriding them. */
(function () {
  var mq = window.matchMedia;
  if (mq && mq('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 768) return;

  var defs = [
    ['.hero-content', 0.06],
    ['.hero__fx', 0.16],
    ['.feature-banner__media', 0.10],
    ['.promo-spotlight__fx', 0.14]
  ];
  var items = [];
  defs.forEach(function (d) {
    document.querySelectorAll(d[0]).forEach(function (el) { items.push({ el: el, speed: d[1] }); });
  });
  if (!items.length) return;

  var ticking = false;
  function update() {
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var it = items[i], r = it.el.getBoundingClientRect();
      if (r.bottom < -240 || r.top > vh + 240) continue;
      var center = r.top + r.height / 2;
      var off = (center - vh / 2) * it.speed * -1;
      it.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    }
    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
